import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexWrap: "wrap"
    },
    rootBadge: {
        height: 20,
        borderRadius: 10,
        color: "#FFF",
        background: "rgba(48, 73, 103, 0.8)",
        fontSize: 10,
        marginRight: 8,
        paddingRight: 8,
        paddingLeft: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "default"
    }
});

const RolesBadges = ({ contractor, customer, employer }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
          {contractor && <div className={classes.rootBadge}>
              <span>Подрядчик</span>
          </div>}
          {customer && <div className={classes.rootBadge}>
              <span>Заказчик</span>
          </div>}
          {employer && <div className={classes.rootBadge}>
              <span>Работодатель</span>
          </div>}
        </div>
    );
};

export default RolesBadges;
